import { REGIONS } from 'app/lib/constants'
import { colors } from 'app/theme'

import type { Config } from '.'

export const productionEuConfig = Object.freeze<Config>({
  auth0: {
    audience: 'https://api.dialoguecorp.com',
    clientId: 'ClI5qyNwtBWQZGXBpFd2g1clQhJGThcO',
    domain: 'auth.dialoguecorp.eu',
    connections: {},
  },
  launchDarkly: {
    clientId: '65fc56dcaace4c1061c9ac29',
  },
  scribe: {
    baseUrl: 'https://scribe.dialoguecorp.eu',
  },
  multipass: {
    baseUrl: 'https://multipass.dialoguecorp.eu',
  },
  coredata: {
    baseUrl: 'https://coredata.dialoguecorp.eu',
  },
  activeMinutes: {
    baseUrl: 'https://active-minutes.dialoguecorp.eu',
  },
  stripePublicKey: 'pk_live_mMeepfha0s3atBB59RWG9mIj',
  theme: {
    applicationBar: {
      backgroundColor: colors.dialogueCharcoal,
    },
  },
  assets_url: 'https://assets.dialoguecorp.eu/maestro/master',
  snowplow: {
    appId: 'presto',
    namespace: 'prod-eu',
    endpoint: 'https://lawnmower.dialoguecorp.eu',
  },
  datadog: {
    applicationId: 'a781e934-0484-4fa0-8547-8c8023e09554',
    clientToken: 'pub734075e67338f25243011439c5a7d69f',
    site: 'datadoghq.eu',
    env: 'prod-eu',
  },
  zendesk: {
    widgetKey: '56208ba2-b5d6-408e-b01f-3b3e141e051c',
  },
  region: REGIONS.UK,
})
